/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Mark_Ready_Confirm_TitleInputs */

const fr_week_session_mark_ready_confirm_title = /** @type {(inputs: Week_Session_Mark_Ready_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer la semaine comme prête ?`)
};

/**

* @param {Week_Session_Mark_Ready_Confirm_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_mark_ready_confirm_title = /** @type {((inputs?: Week_Session_Mark_Ready_Confirm_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Mark_Ready_Confirm_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_mark_ready_confirm_title(inputs)
});